








































































import Vue from 'vue'
import { mapState, mapMutations, mapActions } from 'vuex'
// import Notifications from '@/components/Dashboard/Notifications.vue'
import Settings from '@/components/Dashboard/Settings.vue'
import AppBanner from '@/components/AppBanner.vue'
import LanguageSelector from '~/components/Dashboard/LanguageSelector.vue'
import { updateUser } from '~/api/Users/users.api'

export default Vue.extend({
  components: {
    appLanguageSelector: LanguageSelector,
    // appNotifications: Notifications,
    appSettings: Settings,
    AppBanner,
  },
  data() {
    return {
      language: this.$store.getters.profile.lang,
      loading: false,
    }
  },
  computed: {
    ...mapState(['miniVariant', 'agency']),
    isSmall(): boolean {
      return this.$vuetify.breakpoint.xs
    },
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
    showWhatsapp() {
      return (
        this.$p.isAdmin &&
        this.agency?.parent === process.env.VUE_APP_RECARGAYA_UUID
      )
    },
  },
  methods: {
    ...mapMutations({ toggle: 'TOGGLE_TOOLBAR' }),
    ...mapActions({ logout: 'LOGOUT_USER' }),
  },
  watch: {
    async language(value: string): Promise<void> {
      this.$i18n.locale = value
      this.$vuetify.lang.current = value
      try {
        this.loading = true
        const response = await updateUser({
          uuid: this.$store.getters.profile.uuid,
          lang: value,
        })
        this.$store.commit('UPDATE_PROFILE', response.data)
      } finally {
        this.loading = false
      }
    },
  },
})
